<template>
  <div class="contain">
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="`left`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :md="8">
            <el-form-item :label="$t('플레이스명 / URL명')">
              <el-input v-model="searchForm.q" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item :label="$t('상태')">
              <el-select v-model="searchForm.state" clearable>
                <el-option :label="$t('전체')" value=""></el-option>
                <el-option label="OPEN" value="OPEN"></el-option>
                <el-option label="CLOSED" value="CLOSED"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('PlaceSearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <el-button
        v-if="checkAuthActionAccess('PlaceAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('PlaceUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('PlaceDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
    </div>

    <div class="place-summary">
      <span>전체 {{ summary.totalCount }}건</span>
      <span>OPEN {{ summary.openCount }}건</span>
      <span>CLOSED {{ summary.closedCount }}건</span>
    </div>

    <el-table
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @row-click="handleRowClick"
      @select="handleRowChecked"
      @select-all="handleRowChecked">
      <el-table-column
        :label="tableData.length.toString()"
        type="index"
        width="55"
        align="center"
        sortable
        label-class-name="data_cnt"></el-table-column>
      <el-table-column type="selection" width="45" align="center"></el-table-column>
      <el-table-column label="플레이스명" prop="name" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column label="URL명" prop="urlSlug" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column label="QR URL" min-width="120" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click.stop="copyQrUrl(scope.row)">복사</el-button>
        </template>
      </el-table-column>
      <el-table-column label="상태" prop="state" min-width="100" align="center"></el-table-column>
      <el-table-column label="카테고리" min-width="90" align="center">
        <template slot-scope="scope">
          {{ scope.row.categoryEnabled ? '사용' : '미사용' }}
        </template>
      </el-table-column>
      <el-table-column label="대표 이미지" min-width="100" align="center">
        <template slot-scope="scope">
          <fallback-image
            v-if="scope.row.thumbnailUrl"
            :src="resolvImage(scope.row.thumbnailUrl)"
            fit="cover"
            style="width: 48px; height: 48px"></fallback-image>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="광고" min-width="90" align="center">
        <template slot-scope="scope">
          {{ scope.row.adImageUrl ? '이미지' : '-' }}
        </template>
      </el-table-column>
      <el-table-column v-if="isMng" label="사업장" min-width="140">
        <template slot-scope="scope">
          <template v-if="scope.row.custNm">
            <div>{{ scope.row.custNm }}</div>
            <div class="sub-text">{{ scope.row.custId }}</div>
          </template>
          <span v-else>관리자</span>
        </template>
      </el-table-column>
      <el-table-column label="등록매장" min-width="100" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click.stop="openStoreDialog(scope.row)">{{ scope.row.storeCount || 0 }}개</el-button>
        </template>
      </el-table-column>
      <el-table-column label="관리" min-width="200" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="checkAuthActionAccess('PlaceGet')"
            size="mini"
            icon="el-icon-view"
            @click.stop="openDetail(scope.row)"></el-button>
          <el-button
            v-if="checkAuthActionAccess('PlaceUp')"
            size="mini"
            icon="el-icon-edit"
            @click.stop="openEdit(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="inputForm.title" :visible.sync="dialogFormVisible" fullscreen>
      <el-form
        :model="inputForm"
        label-width="140px"
        :label-position="$device.mobile ? 'top' : 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row :gutter="20">
          <el-col :md="12">
            <el-form-item label="플레이스명" :error="formError.name" required>
              <el-input v-model="inputForm.name" maxlength="50" clearable show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <!-- URL명은 등록 뒤 바꿀 수 없다 — 서버 `PUT /place/{id}` 가 지금과 다른 값이면 400 이다(09-16 결정).
                 화면이 먼저 잠가 사람이 고칠 수 없는 값을 고치려다 400 을 만나지 않게 한다 -->
            <el-form-item label="URL명" :error="formError.urlSlug" required>
              <el-input
                v-model="inputForm.urlSlug"
                maxlength="60"
                :readonly="!isNewPlace"
                :clearable="isNewPlace"
                show-word-limit></el-input>
              <div class="hint-row">
                <span>{{ qrUrl || 'URL명을 입력하면 자동 생성됩니다.' }}</span>
                <template v-if="isNewPlace">
                  <span v-if="slugChecking">확인중...</span>
                  <span v-else-if="slugAvailable === true" class="ok-text">사용 가능</span>
                  <span v-else-if="slugAvailable === false" class="error-text">이미 사용 중</span>
                </template>
                <span v-else>{{ placeText.slugLocked }}</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :md="12" v-if="isMng">
            <el-form-item label="소유 사업장">
              <el-select
                v-model="inputForm.inputCustCd"
                filterable
                remote
                clearable
                :remote-method="searchCust"
                :loading="custSearchLoading"
                placeholder="사업장 검색 (미지정 시 관리자)">
                <el-option
                  v-for="c in custOptions"
                  :key="c.custCd"
                  :label="`${c.custNm}(${c.custId})`"
                  :value="c.custCd"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <!-- 생명주기 축(상태)은 콜팝 관리자·오더엔 내부·사업장 관리자만 바꾼다(서버 보고서 §4).
                 `placeMng` 은 같은 `PUT /place/*` 를 쓰지만 값이 실제로 바뀔 때만 403 이라 미리 잠근다 -->
            <el-form-item label="상태" required>
              <el-tooltip :disabled="canManageLifecycle" :content="roleText.lifecycleDenied" placement="top">
                <span class="lifecycle-control">
                  <el-select v-model="inputForm.state" :disabled="!canManageLifecycle">
                    <el-option label="OPEN" value="OPEN"></el-option>
                    <el-option label="CLOSED" value="CLOSED"></el-option>
                  </el-select>
                </span>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="카테고리 사용">
              <el-switch v-model="inputForm.categoryEnabled"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="홈화면 추가 배너">
              <el-switch v-model="inputForm.homeScreenBannerEnabled"></el-switch>
            </el-form-item>
          </el-col>
          <!-- 콜팝 플레이스 편성 규칙(재정리 §2-3): 해제(특별) = 우리동네 입점과 무관하게 편성, 적용(일반) = 미입점 매장은 일반 1곳만.
               **콜팝 소유 플레이스의 규칙**이다 — 그 밖(오더톡 행사 플레이스 등)은 서버가 이 판정을 걸지 않으므로
               (`PlaceEntryPolicy.conditioned`) 스위치도 안내도 거짓말이 된다. 아래 콜팝 축 칸들과 같은 게이트를 쓴다.
               바꿀 수 있는지는 서버가 플레이스 응답의 `capabilities` 로 답한다(저장 판정과 같은 술어 — 역할 이름으로
               추측하면 범위에 묶인 콜팝 관리자의 저장이 403 이 된다, R-H). 칸이 없는 옛 응답이면 잠근다 -->
          <el-col :md="12" v-if="callpopOwned">
            <el-form-item label="가맹점 조건 해제">
              <el-tooltip
                :disabled="canManageConditionExempt"
                :content="roleText.conditionExemptDenied"
                placement="top">
                <span class="lifecycle-control">
                  <el-switch
                    v-model="inputForm.conditionExemptYn"
                    active-value="Y"
                    inactive-value="N"
                    :disabled="!canManageConditionExempt"></el-switch>
                </span>
              </el-tooltip>
              <span class="hint-row">{{
                inputForm.conditionExemptYn === 'Y'
                  ? '특별 플레이스 — 우리동네 입점 여부와 무관하게 매장을 편성합니다.'
                  : '일반 플레이스 — 우리동네 미입점 매장은 일반 플레이스 1곳에만 편성됩니다.'
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <!-- 소유 파트너는 오더엔 내부 관리자만 바꾼다(서버 델타 브리프 §3 — 그 밖의 역할은 값이 바뀔 때만 403).
                 파트너 목록의 원천은 서버 하나다 — 화면에 코드값을 박지 않는다 -->
            <el-form-item label="소유 파트너">
              <template v-if="canManageOwnerPartner">
                <el-select
                  v-model="inputForm.partnerTpCd"
                  clearable
                  :placeholder="ownerPartnerPlaceholder"
                  :loading="partnerLoading">
                  <el-option
                    v-for="partner in partnerSelectOptions"
                    :key="partner.partnerTpCd"
                    :label="partner.name"
                    :value="partner.partnerTpCd"></el-option>
                </el-select>
                <span v-if="partnerLoadFailed" class="hint-row">{{ placeText.ownerPartnerLoadFailed }}</span>
              </template>
              <!-- 소유 없음은 「편성 통지 미발송」이라는 뜻이다 — 같은 문장을 두 번 적지 않고 색으로 세운다(⑫).
                   고를 수 있는 역할에게는 선택 상자의 placeholder 가 이미 그 문장을 말한다 -->
              <el-tooltip v-else :content="placeText.ownerPartnerDenied" placement="top">
                <span class="lifecycle-control" :class="{ 'warn-text': ownerPartnerMissing }">{{
                  ownerPartnerText
                }}</span>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <!-- 자동 편입·운영지역·기준 주소는 **콜팝 소유 플레이스의 축**이다(M3 리얼 선결 ⑩).
               판정은 서버가 답한 사실(`callpopOwned`)이고 등록 폼에서는 「만들어질 소유」다 —
               화면은 「콜팝인가」를 스스로 묻지 않는다. 안 보이는 칸은 저장 본문에도 실리지 않는다 -->
          <el-col :md="12" v-if="callpopOwned">
            <!-- 자동 편입은 생명주기 축이다(서버 `applyLifecycleFields` 게이트) — 상태와 같은 잠금·같은 툴팁 -->
            <el-form-item label="자동 편입">
              <el-tooltip :disabled="canManageLifecycle" :content="roleText.lifecycleDenied" placement="top">
                <span class="lifecycle-control">
                  <el-switch
                    :value="inputForm.autoEnrollYn === 'Y'"
                    :disabled="!canManageLifecycle"
                    @change="onAutoEnrollChange"></el-switch>
                </span>
              </el-tooltip>
              <span class="hint-row">{{
                inputForm.autoEnrollYn === 'Y' ? placeText.autoEnrollOnHint : placeText.autoEnrollOffHint
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :md="24" v-if="callpopOwned">
            <el-form-item label="운영지역">
              <!-- 운영지역·기준 주소·최대 거리는 생명주기 축이 **아니다** — 플레이스를 편집할 수 있는 역할이면
                   (`placeMng` 포함) 누구나 고친다. 서버 권한 표(B7-a 서버 보고서 ⑥)와 정책(「운영지역·최대배달거리는
                   플레이스 운영자 설정」)이 그렇다. 잠그는 것은 자동편입 토글과 실행 버튼뿐이다 -->
              <place-service-area-editor
                :value="inputForm.serviceArea"
                :session-key="formSeq"
                @input="onServiceAreaInput"></place-service-area-editor>
            </el-form-item>
          </el-col>
          <el-col :md="24" v-if="callpopOwned">
            <el-form-item :label="placeText.baseAddressTitle">
              <place-base-address-field
                :value="baseAddressValue"
                :session-key="formSeq"
                @input="onBaseAddressInput"></place-base-address-field>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="광고 링크" :error="formError.adUrl">
              <el-input
                v-model="inputForm.adUrl"
                maxlength="500"
                clearable
                show-word-limit
                placeholder="https://"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="24">
            <el-form-item label="설명">
              <el-input v-model="inputForm.description" type="textarea" maxlength="250" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="대표 이미지">
              <div class="image-upload-wrap">
                <el-upload
                  action=""
                  class="avatar-uploader"
                  :accept="imageAccept"
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-change="onThumbnailChange">
                  <fallback-image
                    native
                    v-if="hasThumbnail"
                    :src="resolvImage(inputForm.thumbnailFile || inputForm.thumbnailUrl)"
                    class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-button
                  v-if="hasThumbnail"
                  class="image-delete-btn"
                  type="danger"
                  icon="el-icon-delete"
                  size="mini"
                  circle
                  @click="removeThumbnail"></el-button>
              </div>
              <div class="image-guide">
                <span>권장 500x500px · 최소 200x200px · 최대 3000x3000px</span>
                <span>비율 1:1 (정사각형) · {{ imageMaxSizeText }}</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="광고 이미지">
              <div class="image-upload-wrap">
                <el-upload
                  action=""
                  class="avatar-uploader"
                  :accept="imageAccept"
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-change="onAdImageChange">
                  <fallback-image
                    native
                    v-if="hasAdImage"
                    :src="resolvImage(inputForm.adImageFile || inputForm.adImageUrl)"
                    class="avatar ad-avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon ad-avatar-icon"></i>
                </el-upload>
                <el-button
                  v-if="hasAdImage"
                  class="image-delete-btn"
                  type="danger"
                  icon="el-icon-delete"
                  size="mini"
                  circle
                  @click="removeAdImage"></el-button>
              </div>
              <div class="image-guide">
                <span>권장 1080x540px · 최소 400x200px · 최대 3000x1500px</span>
                <span>비율 2:1 (가로형) · {{ imageMaxSizeText }}</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :md="24">
            <el-form-item label="QR URL">
              <div class="qr-preview">
                <div class="qr-preview__url">{{ qrUrl || '-' }}</div>
                <div id="place_qr_preview" class="qr-preview__canvas"></div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :md="24" v-if="!isNewPlace && callpopOwned">
            <el-divider content-position="left">자동 편입</el-divider>
            <place-auto-enroll-panel
              :place-id="inputForm.id"
              :can-manage-lifecycle="canManageLifecycle"
              :reload-seq="formSeq"
              :unsaved-settings="autoEnrollInputsDirty"
              @applied="onAutoEnrollApplied"></place-auto-enroll-panel>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button icon="el-icon-check" :size="size" @click="save" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
        <el-button icon="el-icon-close" :size="size" @click="dialogFormVisible = false">{{ $t('닫기') }}</el-button>
      </div>
    </el-dialog>

    <!-- 켜기 전에 「지금 배치가 돌면 무엇이 들어가는가」를 먼저 보인다(항목 4). 미리보기 패널을 그대로 재사용한다.
         「켜기」는 **이 회차의 미리보기가 성공했을 때만** 열린다(항목 A2) — 무엇이 들어갈지 모르는 채로 켜지 않는다 -->
    <el-dialog title="자동 편입을 켤까요?" :visible.sync="autoEnrollConfirmVisible" width="960px" append-to-body>
      <div class="hint-row">{{ placeText.autoEnrollConfirmHint }} {{ placeText.previewUsesSaved }}</div>
      <place-auto-enroll-panel
        v-if="autoEnrollConfirmVisible"
        :place-id="inputForm.id"
        :can-manage-lifecycle="canManageLifecycle"
        preview-only
        :reload-seq="formSeq"
        @preview="onAutoEnrollPreview"></place-auto-enroll-panel>
      <span slot="footer">
        <el-button :size="size" @click="autoEnrollConfirmVisible = false">취소</el-button>
        <el-tooltip :disabled="autoEnrollPreviewReady" :content="placeText.previewRequiredBeforeOn" placement="top">
          <span class="lifecycle-control">
            <el-button type="primary" :size="size" :disabled="!autoEnrollPreviewReady" @click="confirmAutoEnroll"
              >켜기</el-button
            >
          </span>
        </el-tooltip>
      </span>
    </el-dialog>

    <el-dialog title="플레이스 상세" :visible.sync="detailDialogVisible" width="900px">
      <el-descriptions :column="2" border v-if="detailData">
        <el-descriptions-item label="플레이스명">{{ detailData.name }}</el-descriptions-item>
        <el-descriptions-item label="URL명">{{ detailData.urlSlug }}</el-descriptions-item>
        <el-descriptions-item label="상태">{{ detailData.state }}</el-descriptions-item>
        <el-descriptions-item v-if="isMng" label="소유 사업장">
          <template v-if="detailData.custNm">
            <div>{{ detailData.custNm }}</div>
            <div class="sub-text">{{ detailData.custId }}</div>
          </template>
          <span v-else>관리자</span>
        </el-descriptions-item>
        <el-descriptions-item label="QR URL">{{ detailData.qrUrl }}</el-descriptions-item>
        <el-descriptions-item label="카테고리">{{
          detailData.categoryEnabled ? '사용' : '미사용'
        }}</el-descriptions-item>
        <el-descriptions-item v-if="detailCallpopOwned" label="가맹점 조건">{{
          detailData.conditionExemptYn === 'Y' ? '해제 (특별 플레이스)' : '적용 (일반 플레이스)'
        }}</el-descriptions-item>
        <el-descriptions-item label="소유 파트너">
          <!-- 소유 없음은 「편성 통지 미발송」이라는 뜻이다 — 회색 본문에 묻히지 않게 색으로도 말한다(⑫) -->
          <span :class="{ 'warn-text': detailOwnerPartnerMissing }">{{ detailOwnerPartnerText }}</span>
        </el-descriptions-item>
        <!-- 상세도 폼과 같은 축으로 가른다 — 콜팝 소유가 아닌 플레이스에 이 세 줄은 뜻이 없다(⑩) -->
        <el-descriptions-item v-if="detailCallpopOwned" label="자동 편입">{{
          detailData.autoEnrollYn === 'Y' ? '켜짐' : '꺼짐'
        }}</el-descriptions-item>
        <el-descriptions-item v-if="detailCallpopOwned" label="운영지역">{{
          detailServiceAreaText
        }}</el-descriptions-item>
        <el-descriptions-item v-if="detailCallpopOwned" label="기준 주소" :span="2">{{
          detailBaseAddressText
        }}</el-descriptions-item>
        <el-descriptions-item label="광고 링크" :span="2">{{ detailData.adUrl || '-' }}</el-descriptions-item>
        <el-descriptions-item label="설명" :span="2">{{ detailData.description || '-' }}</el-descriptions-item>
        <el-descriptions-item label="QR 코드" :span="2">
          <div :id="'detail_qr_' + detailData.urlSlug" class="detail-qr"></div>
        </el-descriptions-item>
      </el-descriptions>
      <div class="detail-stores" v-if="detailData && detailData.stores && detailData.stores.length > 0">
        <h4>등록 매장 ({{ detailData.stores.length }}개)</h4>
        <el-tag v-for="store in detailData.stores.slice(0, 20)" :key="store.storeCd" class="detail-store-tag">{{
          store.storeNm
        }}</el-tag>
        <el-tag v-if="detailData.stores.length > 20" class="detail-store-tag" type="info">
          외 {{ detailData.stores.length - 20 }}개
        </el-tag>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="checkAuthActionAccess('PlaceUp')" :size="size" @click="switchDetailToEdit">{{
          $t('수정')
        }}</el-button>
        <el-button :size="size" @click="detailDialogVisible = false">{{ $t('닫기') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="'매장 등록 — ' + (selectedPlaceName || '')" :visible.sync="storeDialogVisible" width="1200px">
      <el-row :gutter="20">
        <el-col :md="12">
          <div class="store-panel">
            <div class="store-panel__header">
              <span>등록된 매장</span>
              <span class="store-panel__count">{{ storeForm.registeredStores.length }}</span>
            </div>
            <div class="store-order-setting">
              <div class="store-order-setting__label">매장 순서 설정</div>
              <div class="store-order-setting__btns">
                <el-button
                  :type="storeForm.storeOrder === 'AUTO' ? 'warning' : 'default'"
                  size="small"
                  @click="storeForm.storeOrder = 'AUTO'">
                  자동 (거리순)
                </el-button>
                <el-button
                  :type="storeForm.storeOrder === 'MANUAL' ? 'warning' : 'default'"
                  size="small"
                  @click="storeForm.storeOrder = 'MANUAL'">
                  수동 (직접 변경)
                </el-button>
                <el-button
                  :type="storeForm.storeOrder === 'PINNED' ? 'warning' : 'default'"
                  size="small"
                  @click="storeForm.storeOrder = 'PINNED'">
                  복합 (상단 고정 + 거리순)
                </el-button>
              </div>
              <div class="store-order-setting__desc">
                <i :class="storeOrderIcon"></i>
                {{ storeOrderDesc }}
              </div>
            </div>
            <div class="store-scroll-list">
              <!-- 복합: 고정 매장은 순위 순으로 위에, 고정끼리 ▲▼ 로 순서 변경(사용자 09-11), 나머지는 거리순 -->
              <template v-if="storeForm.storeOrder === 'PINNED'">
                <div v-for="(store, idx) in pinnedStores" :key="store.storeCd" class="store-row">
                  <span class="store-order">{{ idx + 1 }}</span>
                  <div class="store-row__info">
                    <div class="store-row__name">
                      {{ store.storeNm }} <el-tag size="mini" type="warning">고정</el-tag>
                    </div>
                    <div class="store-row__meta">{{ store.storeId }}</div>
                  </div>
                  <el-button
                    size="mini"
                    icon="el-icon-arrow-up"
                    circle
                    :disabled="idx === 0"
                    @click="movePinned(store, -1)"></el-button>
                  <el-button
                    size="mini"
                    icon="el-icon-arrow-down"
                    circle
                    :disabled="idx === pinnedStores.length - 1"
                    @click="movePinned(store, 1)"></el-button>
                  <el-button size="mini" @click="togglePinned(store)">고정 해제</el-button>
                  <el-button size="mini" icon="el-icon-close" circle @click="removeStore(store)"></el-button>
                </div>
                <div v-for="store in unpinnedStores" :key="store.storeCd" class="store-row">
                  <span class="store-order">-</span>
                  <div class="store-row__info">
                    <div class="store-row__name">{{ store.storeNm }}</div>
                    <div class="store-row__meta">{{ store.storeId }} · 거리순</div>
                  </div>
                  <el-button size="mini" @click="togglePinned(store)">상단 고정</el-button>
                  <el-button size="mini" icon="el-icon-close" circle @click="removeStore(store)"></el-button>
                </div>
              </template>
              <draggable
                v-else-if="storeForm.storeOrder === 'MANUAL'"
                v-model="storeForm.registeredStores"
                handle=".drag-handle"
                animation="200">
                <div v-for="(store, idx) in storeForm.registeredStores" :key="store.storeCd" class="store-row">
                  <span class="drag-handle">⋮⋮</span>
                  <span class="store-order">{{ idx + 1 }}</span>
                  <div class="store-row__info">
                    <div class="store-row__name">{{ store.storeNm }}</div>
                    <div class="store-row__meta">{{ store.storeId }}</div>
                  </div>
                  <el-button size="mini" icon="el-icon-close" circle @click="removeStore(store)"></el-button>
                </div>
              </draggable>
              <template v-else>
                <div v-for="store in storeForm.registeredStores" :key="store.storeCd" class="store-row">
                  <span class="store-order">-</span>
                  <div class="store-row__info">
                    <div class="store-row__name">{{ store.storeNm }}</div>
                    <div class="store-row__meta">{{ store.storeId }}</div>
                  </div>
                  <el-button size="mini" icon="el-icon-close" circle @click="removeStore(store)"></el-button>
                </div>
              </template>
              <div
                v-if="storeForm.registeredStores.length === 0"
                class="store-row"
                style="justify-content: center; color: #909399">
                등록된 매장이 없습니다.
              </div>
            </div>
          </div>
        </el-col>
        <el-col :md="12">
          <div class="store-panel">
            <div class="store-panel__header">
              <span>매장 검색</span>
            </div>
            <div class="store-search">
              <el-input
                v-model="storeForm.availableSearchQ"
                placeholder="매장명 또는 주소"
                @keyup.enter.native="searchAvailableStores"></el-input>
              <el-input
                v-model="storeForm.availableRegion"
                placeholder="지역 (시군구)"
                style="max-width: 160px"
                @keyup.enter.native="searchAvailableStores"></el-input>
              <el-button :size="size" @click="searchAvailableStores">검색</el-button>
            </div>
            <!-- 입점 필터는 콜팝 소유 플레이스의 축이다 — 그 밖(오더톡 행사 플레이스)은 서버가 끈 채로 열고
                 (`entryConditioned`) 입점 표시도 없으므로 토글을 보이지 않는다. 조건 해제 플레이스는 꺼진 채 보인다 -->
            <div class="store-search" v-if="selectedPlaceCallpopOwned">
              <el-checkbox v-model="storeForm.subscribedOnly" @change="searchAvailableStores"
                >우리동네 입점 매장만</el-checkbox
              >
            </div>
            <div class="store-scroll-list" @scroll="loadMoreStores">
              <div v-for="store in storeForm.availableStores" :key="store.storeCd" class="store-row">
                <div class="store-row__info">
                  <div class="store-row__name">
                    {{ store.storeNm }}
                    <el-tag size="mini" :type="entryTag(store).type">{{ entryTag(store).text }}</el-tag>
                  </div>
                  <div class="store-row__meta">{{ availableMetaText(store) }}</div>
                  <div v-if="store.storeAddr" class="store-row__meta">{{ store.storeAddr }}</div>
                  <div v-if="entryTag(store).reason" class="store-row__meta error-text">
                    {{ entryTag(store).reason }}
                  </div>
                </div>
                <el-button size="mini" type="primary" :disabled="entryTag(store).blocked" @click="addStore(store)"
                  >추가</el-button
                >
              </div>
              <div v-if="storeForm.availableLoading" class="store-row" style="justify-content: center; color: #909399">
                로딩중...
              </div>
              <!-- 「못 읽었다」와 「없다」는 다른 답이다 — 실패에는 다시 시도할 길을 준다(자동 편입 패널과 같은 규율) -->
              <div v-else-if="storeForm.availableFailed" class="store-row store-empty error-text">
                {{ storeForm.availableFailed }}
                <el-button size="mini" @click="searchAvailableStores">{{ placeText.retry }}</el-button>
              </div>
              <!-- 후보 0건은 장애가 아니라 답이다 — 문구는 플레이스의 소유 축이 가른다(⑧) -->
              <div v-else-if="storeForm.availableStores.length === 0" class="store-row store-empty muted-text">
                {{ availableEmptyText }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 편성 저장의 400 은 「어느 매장이 왜 안 되는가」다 — 사라지는 토스트가 아니라 다이얼로그 안에 남긴다(⑨) -->
      <div v-if="storeForm.saveFailed" class="store-save-failed error-text">{{ storeForm.saveFailed }}</div>
      <div slot="footer" class="store-dialog-footer">
        <div class="store-dialog-footer__status">
          <i :class="storeOrderIcon"></i>
          {{ storeOrderStatus }}
        </div>
        <div>
          <el-button icon="el-icon-close" :size="size" @click="storeDialogVisible = false">취소</el-button>
          <el-button v-if="checkAuthActionAccess('PlaceStoreUp')" type="primary" :size="size" @click="saveStores"
            >저장 ({{ storeForm.registeredStores.length }}개)</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fileRemoval, hasStoredImage } from '@/utils/storedFile'
/* global AraleQRCode */
import draggable from 'vuedraggable'
import mainVueMixin from '@/mixins/mainVueMixin'
import PlaceAutoEnrollPanel from '@/components/place/PlaceAutoEnrollPanel.vue'
import PlaceBaseAddressField from '@/components/place/PlaceBaseAddressField.vue'
import PlaceServiceAreaEditor from '@/components/place/PlaceServiceAreaEditor.vue'
import { httpErrorMessage } from '@/plugins/http/policy'
import { ROLE_TEXT, canManagePlaceLifecycle, canManagePlaceOwnerPartner, hasCallpopRole } from '@/utils/adminRole'
import { initData, QR_WEB_URL } from '@/utils/constants'
import { CALLPOP_TEXT } from '@/utils/callpopText'
import { copyText } from '@/utils/clipboard'
import { CUST_OPTIONS_API, custOptionsQuery } from '@/utils/custOptions'
import { pageRows } from '@/utils/pagedList'
import { PLACE_IMAGE_ACCEPT, PLACE_IMAGE_TEXT, placeImageRejection } from '@/utils/placeImage'
import {
  PLACE_AREA_TEXT,
  areaLabel,
  autoEnrollInputsChanged,
  availableStoresEmptyText,
  baseAddressOf,
  baseAddressText,
  callpopFieldAxis as callpopFieldAxisOf,
  canDesignateConditionExemptOf,
  candidateDistanceText,
  candidateEntryView,
  entryBlockedText,
  initServiceArea,
  isCallpopOwned,
  isOwnerPartnerEmpty,
  ownerPartnerTransfers,
  isServiceAreaEmpty,
  ownerPartnerText as ownerPartnerTextOf,
  placeFieldsFromServer,
  placeSavePayload,
  serviceAreaAutoSetMessage,
  serviceAreaSummary,
  subscribedOnlyDefault,
  subscriptionText as subscriptionTextOf,
} from '@/utils/placeServiceArea'

/** 소유 파트너 목록은 **부가 조회**다 — 못 읽어도 화면은 현재 값을 그대로 보인다(규약 §16.170·§16.175 옵트아웃) */
const PARTNER_LIST_CONFIG = { logoutOn403: false, showErrorMessage: false, showLoading: false }

/** 저장 결과 되읽기 — 실패해도 할 말이 없다(저장은 이미 성공했다). 스피너도 토스트도 띄우지 않는다 */
const PLACE_READBACK_CONFIG = { logoutOn403: false, showErrorMessage: false, showLoading: false }

/**
 * 편성 다이얼로그의 조회·저장 — 실패를 **다이얼로그 안 안내**로 답한다(규약 §16.175 옵트아웃).
 *
 * 후보 조회의 0건·실패와 저장의 400(「어느 매장이 왜 안 되는가」)은 이 화면이 직접 답해야 하는 것이고,
 * 인터셉터의 사라지는 빨간 토스트가 함께 뜨면 화면이 두 말을 한다. 403 은 옵트아웃하지 않는다 —
 * 편성은 이 화면의 본체이므로 그 403 은 「이 세션으로는 못 한다」가 맞다.
 */
const PLACE_STORE_CONFIG = { showErrorMessage: false }

export default {
  name: 'PlaceListView',
  mixins: [mainVueMixin],
  components: {
    draggable,
    PlaceAutoEnrollPanel,
    PlaceBaseAddressField,
    PlaceServiceAreaEditor,
  },
  data: function () {
    const data = initData()
    data.url = '/place'
    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()
    data.summary = { totalCount: 0, openCount: 0, closedCount: 0 }
    // 목록 응답의 호출자 권한(`capabilities`) — 상세 조회가 없는 등록 폼이 이 값으로 묻는다([add])
    data.listCapabilities = null
    data.detailDialogVisible = false
    data.detailData = null
    data.storeDialogVisible = false
    data.availableSeq = 0 // 후보 매장 조회 세대 — 다이얼로그를 다시 열어도 이어진다(늦게 온 옛 응답 배제)
    data.selectedPlaceId = null
    data.selectedPlaceName = ''
    // 편성 다이얼로그가 보는 플레이스의 소유 축 — 목록 행이 서버 사실을 싣고 온다(`GET /place` 항목)
    data.selectedPlaceCallpopOwned = false
    data.slugAvailable = null
    data.slugChecking = false
    data.slugCheckTimer = null
    data.storeForm = this.initStoreForm()
    data.custOptions = []
    data.custSearchLoading = false
    data.roleText = ROLE_TEXT
    data.placeText = PLACE_AREA_TEXT
    data.imageAccept = PLACE_IMAGE_ACCEPT
    data.partnerOptions = []
    data.partnerLoading = false
    data.partnerLoadFailed = false
    data.autoEnrollConfirmVisible = false
    // 폼을 채울 때마다 오르는 **편집 세대** — 「언제 다시 읽는가」(자동 편입 패널)와 「이 주소 선택이
    // 아직 내 것인가」(운영지역·기준 주소 편집기)의 답이 같은 사건이라 값 하나가 둘 다 답한다
    data.formSeq = 0
    // 서버에서 읽어 온 원본 — 자동 편입 입력이 저장 뒤 값과 같은지 묻는 기준이다(`autoEnrollInputsChanged`)
    data.savedPlaceFields = placeFieldsFromServer(null)
    // 확인 대화상자의 **이번 회차** 미리보기가 성공한 대상 — 성공 전에는 「켜기」를 열지 않는다
    data.autoEnrollPreviewOkId = null
    return data
  },
  computed: {
    /** 복합 모드의 고정 매장 — registeredStores 의 순서가 고정 순위다 */
    pinnedStores() {
      return this.storeForm.registeredStores.filter((item) => item.pinned)
    },
    unpinnedStores() {
      return this.storeForm.registeredStores.filter((item) => !item.pinned)
    },
    storeOrderIcon() {
      return this.storeForm.storeOrder === 'AUTO' ? 'el-icon-sort' : 'el-icon-rank'
    },
    storeOrderDesc() {
      if (this.storeForm.storeOrder === 'AUTO') return '매장까지의 거리 기준으로 자동 정렬됩니다.'
      if (this.storeForm.storeOrder === 'PINNED') return '고정 매장은 위에 순서대로, 나머지는 거리순으로 보입니다.'
      return '핸들을 드래그하여 순서를 변경하세요.'
    },
    storeOrderStatus() {
      if (this.storeForm.storeOrder === 'AUTO') return '자동 (거리순) 정렬 적용됨'
      if (this.storeForm.storeOrder === 'PINNED') return `복합 정렬 적용됨 (고정 ${this.pinnedStores.length}개)`
      return '수동 순서 적용됨'
    },
    authId() {
      return this.$store.getters['auth/authId']
    },
    /** 세션의 역할 **전부** — 콜팝 사업 역할 판정만 이 축을 쓴다(겸직 계정에서 서버와 답이 갈리지 않게) */
    auths() {
      return this.$store.getters['auth/auths']
    },
    /** 오더엔 내부 관리자인가 — 소유 파트너를 바꿀 수 있는 역할과 **같은 집합**이다(서버 `CallerScope.isInternal`) */
    isMng() {
      return canManagePlaceOwnerPartner(this.authId)
    },
    /** 생성·삭제·상태·자동편입 — 판정은 `utils/adminRole` 한 곳이다(서버 `CallerScope` 와 같은 집합) */
    canManageLifecycle() {
      return canManagePlaceLifecycle(this.authId)
    },
    /**
     * 조건해제(특별) 지정 — **서버가 답한다**(`utils/placeServiceArea` 의 `canDesignateConditionExemptOf`). 폼이 그 답을
     * 들고 있다: 수정 폼은 상세 응답의 `capabilities` 가 폼에 실려 오고, 등록 폼은 목록 응답의 것을 [add] 가 담는다
     */
    canManageConditionExempt() {
      return canDesignateConditionExemptOf(this.inputForm)
    },
    /** 등록 모드인가 — URL명 잠금·중복 확인·자동 편입 패널이 같은 질문을 본다 */
    isNewPlace() {
      return this.inputForm.statu === 'I'
    },
    /**
     * 소유 파트너를 **바꿀 수 있는가** — 서버 델타 브리프 §3 의 「오더엔 내부 관리자만」이다.
     * 콜팝 관리자·사업장 관리자·플레이스 관리자는 같은 값 되보내기만 통과하므로 화면은 읽기로 보인다.
     */
    canManageOwnerPartner() {
      return canManagePlaceOwnerPartner(this.authId)
    },
    /**
     * 콜팝 사업 역할인가 — 등록 폼이 만들 소유를 서버와 같은 말로 답하기 위해서만 쓴다.
     *
     * **역할 목록 전체**를 본다(`authId` 는 첫 역할 하나다). 서버 `CallerScope.isCallpop` 이 모든 역할을
     * 보고 겸직을 전제하므로, 이 축이 갈리면 화면이 「소유 없이 등록됩니다」라고 말한 저장이 콜팝 소유로
     * 생성되어 편성 통지가 나간다(R1 medium #2).
     */
    isCallpopCaller() {
      return hasCallpopRole(this.auths)
    },
    /** 지금 고른 소유 파트너 항목 — 서버가 준 `callpopRules` 를 들고 있는 행이다 */
    selectedPartnerOption() {
      return this.partnerOptions.find((partner) => partner.partnerTpCd === this.inputForm.partnerTpCd) || null
    },
    /**
     * **콜팝 축의 두 답** — 보이는가(`shown`)와 본문에 싣는가(`inBody`). 판정은 순수 함수 한 곳이다.
     *
     * 화면은 「콜팝인가」를 판정하지 않는다: 수정은 서버가 답한 사실(`callpopOwned`), 등록은 **만들어질
     * 소유**(서버 생성 규칙과 같은 말), 본문은 그 둘의 곱이다 — 근거는 `callpopFieldAxis` 주석에 있다.
     */
    callpopFieldAxis() {
      return callpopFieldAxisOf({
        isNew: this.isNewPlace,
        saved: this.savedPlaceFields,
        form: this.inputForm,
        callpopCaller: this.isCallpopCaller,
        ownerPartnerEditable: this.canManageOwnerPartner,
        partner: this.selectedPartnerOption,
      })
    },
    /**
     * 자동편입·운영지역·기준 주소 UI 와 콜팝 어휘를 보이는가 — **지금 걸려 있는 규칙**이 정한다.
     *
     * 수정에서 소유 상자를 고쳐도 이 값은 **저장 전까지 서버 사실 그대로**다. 지금 걸려 있는 규칙이 그것이고,
     * 소유 파트너 목록은 못 읽어도 화면이 도는 부가 조회라([PARTNER_LIST_CONFIG]) 그 실패로 콜팝 플레이스의
     * 자동 편입 패널이 사라지면 안 된다.
     */
    callpopOwned() {
      return this.callpopFieldAxis.shown
    },
    /**
     * **저장 본문에 콜팝 축을 실을까** — 「보였고」 그리고 「이 저장 뒤에도 콜팝 소유일」 때만이다.
     *
     * 판정은 [callpopFieldAxis] 한 곳이고 이 자리는 그 답의 한 칸을 읽는다 — 표시와 본문을 각자
     * 조립하면 「어느 소유가 정하는가」가 갈린다(R2 가 잡은 결함이 그것이다).
     */
    callpopFieldsInBody() {
      return this.callpopFieldAxis.inBody
    },
    detailCallpopOwned() {
      return isCallpopOwned(this.detailData)
    },
    /** 저장된 플레이스에 소유가 없다 — 편성 통지가 나가지 않는다는 사실을 눈에 보이게 말할 자리(⑫) */
    ownerPartnerMissing() {
      return !this.isNewPlace && isOwnerPartnerEmpty(this.inputForm.partnerTpCd)
    },
    detailOwnerPartnerMissing() {
      return !!this.detailData && isOwnerPartnerEmpty(this.detailData.partnerTpCd)
    },
    /**
     * 선택 상자의 옵션 — 지금 값이 목록에 없으면 **그 값을 남긴다**(`placeOptionsOf` 와 같은 이유).
     * 잘린 자리에 현재 소유가 들어 있으면 태그가 숫자로 되돌아가 무엇에 묶였는지 못 읽는다.
     *
     * 「비었는가」는 `isOwnerPartnerEmpty` 한 술어가 답한다 — `clearable` 이 올리는 `''` 를 값으로 읽으면
     * 옛 이름표를 단 유령 옵션이 생겨, 지운 뒤에도 옛 파트너가 골라진 것처럼 보인다.
     */
    partnerSelectOptions() {
      const current = this.inputForm.partnerTpCd
      if (isOwnerPartnerEmpty(current)) return this.partnerOptions
      if (this.partnerOptions.some((partner) => partner.partnerTpCd === current)) return this.partnerOptions

      return this.partnerOptions.concat([{ partnerTpCd: current, name: this.inputForm.partnerTpNm || String(current) }])
    },
    /**
     * 바꿀 수 없는 역할이 보는 읽기 문구 — 등록의 빈 값의 뜻은 **만들어질 소유**가 정하고, 문장은
     * 「고를 수 있는가」로 한 번 더 갈린다(선택 상자가 없는 사람에게 「비우면」은 할 수 없는 선택이다).
     */
    ownerPartnerText() {
      return ownerPartnerTextOf(this.inputForm, {
        isNew: this.isNewPlace,
        callpopOwned: this.callpopOwned,
        ownerPartnerEditable: this.canManageOwnerPartner,
      })
    },
    /**
     * 고를 수 있는 역할이 보는 빈 값 안내 — 같은 사실을 placeholder 로 말한다.
     *
     * 이 자리는 **오더엔 내부 관리자만** 본다(`canManageOwnerPartner`). 그 역할이 비우고 저장하면 소유
     * 없음이므로([newPlaceCallpopOwned] 의 첫 갈래) 등록·수정 모두 「없음」 계열 문구가 맞다.
     */
    ownerPartnerPlaceholder() {
      return ownerPartnerTextOf({}, { isNew: this.isNewPlace, callpopOwned: false, ownerPartnerEditable: true })
    },
    detailOwnerPartnerText() {
      return ownerPartnerTextOf(this.detailData, { isNew: false })
    },
    /**
     * 후보 0건의 답 — 문구는 순수 모듈이 만들고 화면은 그릴 자리만 정한다(⑧).
     *
     * 검색 조건은 입력칸이 아니라 **지금 목록을 만든 조건**(`availableFilter`)을 넘긴다. 입력칸의 나중
     * 값을 넘기면 검색을 누르지 않고 글자만 지운 순간 문구가 「검색어를 확인하라」를 버린다.
     */
    availableEmptyText() {
      return availableStoresEmptyText({
        callpopOwned: this.selectedPlaceCallpopOwned,
        subscribedOnly: this.storeForm.subscribedOnly,
        searchQ: this.storeForm.availableFilter.q,
        region: this.storeForm.availableFilter.region,
      })
    },
    /**
     * 자동 편입의 입력(운영지역·기준 주소 여섯·최대 거리)이 **읽어 온 값과 다른가**.
     *
     * 미리보기도 배치도 서버에 저장된 설정으로 돈다. 이 값이 참이면 사람이 확인한 목록과 저장 뒤 실제
     * 편입 대상이 갈리므로, 화면은 켜기·실행을 열지 않고 먼저 저장하라고 말한다.
     */
    autoEnrollInputsDirty() {
      return autoEnrollInputsChanged(this.savedPlaceFields, this.inputForm)
    },
    /** 이번 회차의 미리보기를 **지금 이 플레이스로** 읽었는가 — 「켜기」의 선행 조건(항목 A2) */
    autoEnrollPreviewReady() {
      return this.autoEnrollPreviewOkId !== null && this.autoEnrollPreviewOkId === this.inputForm.id
    },
    detailServiceAreaText() {
      const summary = serviceAreaSummary(this.detailData && this.detailData.serviceArea)
      const areas = ((this.detailData && this.detailData.serviceArea && this.detailData.serviceArea.areas) || []).map(
        areaLabel
      )

      return areas.length > 0 ? `${summary} — ${areas.join(', ')}` : summary
    },
    detailBaseAddressText() {
      // 상세 응답도 폼과 같은 모양으로 읽는다(`maxDeliveryKm` 하나 — 별칭 갈래는 없다). 문장은 순수 모듈이 만든다
      return baseAddressText(placeFieldsFromServer(this.detailData))
    },
    /** 기준 주소 편집기가 다루는 축만 넘긴다 — 폼 전체를 컴포넌트에 주지 않는다 */
    baseAddressValue() {
      return baseAddressOf(this.inputForm)
    },
    /** 안내 문구의 크기는 판정과 **같은 상수**에서 나온다 — 서버 상한이 바뀌면 둘이 함께 바뀐다 */
    imageMaxSizeText() {
      return PLACE_IMAGE_TEXT.maxSize
    },
    qrUrl() {
      if (!this.inputForm.urlSlug) return ''
      const base = (QR_WEB_URL || 'https://order.ordern.co.kr').replace(/\/$/, '')
      return `${base}/?qr=${encodeURIComponent(this.inputForm.urlSlug)}`
    },
    /** 그릴 썸네일·광고 이미지가 있는가 — 판정은 `utils/storedFile` 한 곳 */
    hasThumbnail() {
      return hasStoredImage(this.inputForm, 'thumbnailUrl', 'thumbnailFile')
    },
    hasAdImage() {
      return hasStoredImage(this.inputForm, 'adImageUrl', 'adImageFile')
    },
  },
  watch: {
    'inputForm.urlSlug': function (val) {
      this.slugAvailable = null
      this.formError.urlSlug = ''

      if (this.slugCheckTimer) {
        clearTimeout(this.slugCheckTimer)
      }

      this.$nextTick(() => {
        this.showPlaceQr()
      })

      // 중복 확인은 등록 모드에서만 돈다 — 수정 모드의 URL명은 잠겨 있어 물을 것이 없다(항목 1)
      if (!val || !this.isNewPlace) return

      this.slugCheckTimer = setTimeout(() => {
        this.checkSlug()
      }, 300)
    },
    dialogFormVisible: function (visible) {
      if (!visible) return
      this.$nextTick(() => {
        this.showPlaceQr()
      })
    },
  },
  created: function () {
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      300
    )
  },
  methods: {
    initSearchForm: function () {
      return {
        q: '',
        state: '',
      }
    },
    initInputForm: function () {
      return {
        statu: 'I',
        title: '',
        id: null,
        name: '',
        urlSlug: '',
        state: 'OPEN',
        categoryEnabled: false,
        homeScreenBannerEnabled: true,
        description: '',
        thumbnailUrl: '',
        thumbnailFile: '',
        adImageUrl: '',
        adImageFile: '',
        adUrl: '',
        storeOrder: 'AUTO',
        conditionExemptYn: 'N',
        inputCustCd: null,
        // 서버가 답한 소유 축(읽기 전용) — 등록 폼은 아직 그 사실이 없으므로 거짓으로 시작한다
        callpopOwned: false,
        // 새 세대 필드(B3·B6·B6-2) — 화면은 자기가 **보이는** 것을 실어 보낸다(서버는 부재 = 불변)
        autoEnrollYn: 'N',
        serviceArea: initServiceArea(),
        maxDeliveryKm: null,
        partnerTpCd: null,
        partnerTpNm: '',
        baseAddr: '',
        baseAddrDtl: '',
        baseZipCd: '',
        baseLat: null,
        baseLng: null,
        baseBjdCd: '',
      }
    },
    initFormError: function () {
      return {
        name: '',
        urlSlug: '',
        adUrl: '',
      }
    },
    initStoreForm: function () {
      return {
        storeOrder: 'AUTO',
        conditionExemptYn: 'N',
        registeredStores: [],
        availableStores: [],
        availableSearchQ: '',
        availableRegion: '',
        subscribedOnly: true,
        availablePage: 0,
        availableHasMore: false,
        availableLoading: false,
        // 「못 읽었다」와 「저장이 막혔다」는 각자 자리를 갖는다 — 빈 문자열이면 할 말이 없다는 뜻이다
        availableFailed: '',
        saveFailed: '',
        // **지금 목록을 만든** 검색 조건 — 「왜 비었나」의 답이 입력칸의 나중 값으로 갈리지 않게 찍어 둔다
        availableFilter: { q: '', region: '' },
      }
    },
    handleRowClick: function (val) {
      if (val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    handleRowChecked: function (selection) {
      this.btn.delDisabled = selection.length === 0
      this.checkedData = selection.map((item) => item.id)
    },
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchForm,
        function (result) {
          this.tableData = result.items || []
          this.summary = {
            totalCount: result.totalCount || 0,
            openCount: result.openCount || 0,
            closedCount: result.closedCount || 0,
          }
          this.listCapabilities = result.capabilities || null
          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true
          this.selectData = null
        }.bind(this)
      )
    },
    add: function () {
      // 등록 폼은 상세가 없다 — 호출자 권한은 목록 응답의 것이다(같은 호출자·같은 답, 서버 H2 계약)
      this.inputForm = Object.assign(this.initInputForm(), { capabilities: this.listCapabilities })
      this.beginFormSession(null)
      this.formError = this.initFormError()
      this.slugAvailable = null
      this.custOptions = []
      this.dialogFormVisible = true
      this.inputForm.title = '플레이스 추가'
      this.btn.saveDisabled = false
      this.loadPartnerOptions()
    },
    openEdit: function (row) {
      this.selectData = row
      this.up()
    },
    up: function () {
      if (!this.selectData) return

      this.mainVue.$axios.get(
        `${this.url}/${this.selectData.id}`,
        function (result) {
          this.applyDetailToForm(result)
          if (result.custCd && result.custNm) {
            this.custOptions = [{ custCd: result.custCd, custNm: result.custNm, custId: result.custId }]
          } else {
            this.custOptions = []
          }
          this.formError = this.initFormError()
          this.slugAvailable = true
          this.dialogFormVisible = true
          this.btn.saveDisabled = false
          this.loadPartnerOptions()
        }.bind(this)
      )
    },
    /** 상세 응답 → 수정 폼. 새 세대 필드는 `placeFieldsFromServer` 가 **마지막에** 덮어 정본이 된다 */
    applyDetailToForm: function (result) {
      this.inputForm = Object.assign(
        this.initInputForm(),
        result,
        {
          statu: 'U',
          title: '플레이스 수정',
          thumbnailFile: '',
          adImageFile: '',
          inputCustCd: result.custCd || null,
        },
        placeFieldsFromServer(result)
      )
      this.beginFormSession(result)
    },
    /**
     * 폼을 채웠다 — 이 한 사건이 **세 가지**를 한꺼번에 답한다.
     *
     * 1. 자동 편입 패널이 다시 읽을 때(`reloadSeq`) — 신호가 둘이면 안 올린 자리가 반드시 생긴다.
     * 2. 주소 선택 결과가 아직 이 세션의 것인지(`sessionKey`) — 앞 플레이스에서 고르던 주소는 남의 것이다.
     * 3. 「바뀌었나」의 기준점(`savedPlaceFields`) — 비교 대상은 **서버가 준 값**이지 폼의 옛 상태가 아니다.
     */
    beginFormSession: function (detail) {
      this.savedPlaceFields = placeFieldsFromServer(detail)
      this.autoEnrollPreviewOkId = null
      this.formSeq += 1
    },
    /**
     * 소유 파트너 후보 — **못 읽어도 화면은 돈다**([PARTNER_LIST_CONFIG]). 바꿀 수 없는 역할은 부르지 않는다:
     * 그 역할에게 이 조회의 403 은 답이 아니라 잡음이다.
     */
    loadPartnerOptions: async function () {
      if (!this.canManageOwnerPartner) return
      this.partnerLoading = true
      try {
        const response = await this.$axios.get(`${this.url}/partners`, PARTNER_LIST_CONFIG)
        const rows = (response.data && response.data.items) || []
        this.partnerOptions = rows
          .filter((row) => row && row.partnerTpCd !== null && row.partnerTpCd !== undefined)
          .map((row) => ({
            partnerTpCd: row.partnerTpCd,
            name: row.name || row.code || String(row.partnerTpCd),
            // 「이 파트너를 고르면 콜팝 규칙이 걸리는가」 — 등록 폼이 세 UI 를 가르는 유일한 재료다
            callpopRules: row.callpopRules === true,
          }))
        this.partnerLoadFailed = false
      } catch (error) {
        this.partnerOptions = []
        this.partnerLoadFailed = true
      } finally {
        this.partnerLoading = false
      }
    },
    openDetail: function (row) {
      this.mainVue.$axios.get(
        `${this.url}/${row.id}`,
        function (result) {
          this.detailData = result
          this.detailDialogVisible = true
          this.$nextTick(() => {
            this.showDetailQr(result.urlSlug)
          })
        }.bind(this)
      )
    },
    showDetailQr: function (urlSlug) {
      if (!urlSlug || typeof AraleQRCode === 'undefined') return
      const base = (QR_WEB_URL || 'https://order.ordern.co.kr').replace(/\/$/, '')
      const qrUrl = `${base}/?qr=${encodeURIComponent(urlSlug)}`
      const target = document.getElementById('detail_qr_' + urlSlug)
      if (!target) return
      target.innerHTML = ''
      target.appendChild(new AraleQRCode({ text: qrUrl, size: 140 }))
    },
    switchDetailToEdit: function () {
      if (!this.detailData) return
      this.detailDialogVisible = false
      this.selectData = this.detailData
      this.up()
    },
    del: function () {
      if (this.checkedData.length === 0) return

      this.mainVue
        .$confirm('플레이스를 삭제하시겠습니까?', this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              `${this.url}/${this.checkedData.join(',')}`,
              function () {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this)
            )
          }.bind(this)
        )
    },
    checkSlug: async function () {
      if (!this.inputForm.urlSlug) return
      this.slugChecking = true

      const query = this.inputForm.id ? `?excludeId=${this.inputForm.id}` : ''
      const encodedSlug = encodeURIComponent(this.inputForm.urlSlug)
      try {
        const response = await this.$axios.patch(`${this.url}/chk/${encodedSlug}${query}`)
        this.slugAvailable = response.data.available
        this.formError.urlSlug = response.data.available ? '' : '이미 사용 중인 URL명입니다.'
      } finally {
        this.slugChecking = false
      }
    },
    save: async function () {
      this.formError = this.initFormError()

      if (!this.inputForm.name) {
        this.formError.name = '플레이스명을 입력하세요.'
        return
      }
      if (!this.inputForm.urlSlug) {
        this.formError.urlSlug = 'URL명을 입력하세요.'
        return
      }
      if (this.inputForm.adUrl && !this.inputForm.adUrl.startsWith('https://')) {
        this.formError.adUrl = '광고 링크는 https:// 로 시작해야 합니다.'
        return
      }

      // 수정 모드의 URL명은 잠겨 있다 — 물을 값이 바뀌지 않으므로 중복 확인도 등록에서만 한다
      if (this.isNewPlace) {
        await this.checkSlug()
        if (this.slugAvailable === false) {
          return
        }
      }

      // 소유를 옮기는 저장은 되돌릴 수 없는 일을 한다(옛 파트너의 운영자 연결 해제, 결정 35) — 먼저 묻는다
      if (
        !this.isNewPlace &&
        this.canManageOwnerPartner &&
        ownerPartnerTransfers(this.savedPlaceFields, this.inputForm)
      ) {
        try {
          await this.$confirm(this.placeText.ownerPartnerTransferConfirm, this.placeText.ownerPartnerTransferTitle, {
            type: 'warning',
          })
        } catch (cancelled) {
          return
        }
      }

      // 보이는 것이 곧 보내는 것이다 — 소유 파트너는 내부 관리자만(권한 표 ⑥), 자동편입·운영지역·기준
      // 주소는 콜팝 소유 플레이스만(⑩). 안 실은 키는 서버가 손대지 않는다(부재 = 불변)
      const payload = placeSavePayload(this.inputForm, {
        ownerPartner: this.canManageOwnerPartner,
        callpopFields: this.callpopFieldsInBody,
      })
      // 기준 주소를 보내면서 운영지역을 비웠다면 서버가 그 시군구로 자동 설정한다(결정 32) —
      // 저장 응답에는 그 사실이 없으므로 저장 뒤 단건을 다시 읽어 확인한다
      const expectsAutoArea = !!payload.baseAddr && payload.serviceArea === null
      const placeId = this.inputForm.id

      if (this.isNewPlace) {
        this.mainVue.$axios.add(
          this.url,
          payload,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.dialogFormVisible = false
            this.search()
            if (expectsAutoArea) this.reportAutoServiceArea(result && result.id)
          }.bind(this)
        )
      } else {
        this.mainVue.$axios.up(
          `${this.url}/${placeId}`,
          payload,
          this.formError,
          function () {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.dialogFormVisible = false
            this.search()
            if (expectsAutoArea) this.reportAutoServiceArea(placeId)
          }.bind(this)
        )
      }
    },
    /**
     * 서버가 운영지역을 채웠는지 확인하고, 채웠으면 **알림 한 번**으로 말한다.
     *
     * 등록과 수정이 같은 함수를 지난다(등록은 저장 응답의 `id`). 조회 실패나 「안 채워짐」은 **아무 말도
     * 하지 않는다** — 이것은 저장의 일부가 아니라 저장 결과를 읽어 주는 부가 조회이고, 그 실패가
     * 「저장 성공」 뒤에 빨간 토스트로 따라붙으면 화면이 두 말을 한다.
     */
    reportAutoServiceArea: async function (placeId) {
      if (!placeId) return
      try {
        const response = await this.$axios.get(`${this.url}/${placeId}`, PLACE_READBACK_CONFIG)
        const message = serviceAreaAutoSetMessage(response.data && response.data.serviceArea)
        if (message) this.mainVue.$message({ type: 'success', message })
      } catch (error) {
        // 확인하지 못했을 뿐이다 — 저장은 이미 성공했고 사람이 할 일이 없다
      }
    },
    /** 편집기·입력 컴포넌트가 올린 값을 폼에 접는다 — 폼은 새 객체로 갈아 끼운다 */
    onServiceAreaInput: function (serviceArea) {
      this.inputForm = Object.assign({}, this.inputForm, { serviceArea })
    },
    onBaseAddressInput: function (base) {
      this.inputForm = Object.assign({}, this.inputForm, base)
    },
    /**
     * 자동 편입 토글 — 켜려는 순간 **미리보기를 먼저 보이고** 확인을 받는다(항목 4).
     *
     * 운영지역이 비어 있으면 켤 수 없다고 말한다: 서버는 그 플레이스를 `NO_SERVICE_AREA` 로 건너뛸 뿐
     * 막지 않으므로, 화면이 말하지 않으면 사람은 「켰는데 아무 일도 안 일어난다」만 보게 된다.
     *
     * **바꾼 설정은 먼저 저장한다**(항목 A1): 미리보기는 서버에 **저장된** 운영지역·기준 주소·최대 거리로
     * 계산되므로, 같은 다이얼로그에서 그 값을 고친 직후 켜면 사람이 확인한 목록과 저장 뒤 실제 편입
     * 대상이 갈린다(방금 지역을 넣었는데 「운영지역이 설정되지 않아…」가 뜨기도 한다).
     */
    onAutoEnrollChange: function (on) {
      if (!on) {
        this.inputForm = Object.assign({}, this.inputForm, { autoEnrollYn: 'N' })

        return
      }
      if (isServiceAreaEmpty(this.inputForm.serviceArea)) {
        this.mainVue.$message({ type: 'warning', message: this.placeText.autoEnrollNeedsArea })

        return
      }
      // 아직 저장 전인 플레이스는 미리볼 대상이 서버에 없다 — 물을 것이 없으므로 그대로 켠다
      if (!this.inputForm.id) {
        this.inputForm = Object.assign({}, this.inputForm, { autoEnrollYn: 'Y' })

        return
      }
      if (this.autoEnrollInputsDirty) {
        this.mainVue.$message({ type: 'warning', message: this.placeText.unsavedBeforeAutoEnroll })

        return
      }
      // 확인창의 미리보기는 자기 회차를 스스로 연다 — 여기서 세대를 올리면 같은 preview 가 두 번 나간다
      this.autoEnrollPreviewOkId = null
      this.autoEnrollConfirmVisible = true
    },
    /** 확인창 패널이 알려 주는 **대상 + 이번 회차의 성공 여부** — 실패·새 조회는 앞선 성공을 무효로 만든다 */
    onAutoEnrollPreview: function (result) {
      this.autoEnrollPreviewOkId = result && result.ok ? result.placeId : null
    },
    confirmAutoEnroll: function () {
      if (!this.autoEnrollPreviewReady) return
      this.autoEnrollConfirmVisible = false
      this.inputForm = Object.assign({}, this.inputForm, { autoEnrollYn: 'Y' })
    },
    /** 실제 편입이 돌면 편성 매장 수가 바뀐다 — 목록을 다시 읽는다 */
    onAutoEnrollApplied: function () {
      this.search()
    },
    searchCust: function (query) {
      if (!query || query.length < 1) {
        this.custOptions = []
        return
      }
      if (this._custSearchTimer) clearTimeout(this._custSearchTimer)
      this._custSearchTimer = setTimeout(() => {
        this.custSearchLoading = true
        // 셀렉트 전용이라 **전량**이다(`useYn: 'Y'` 는 종전 서버 기본값을 요청에 적어 둔 것)
        this.$axios
          .get(CUST_OPTIONS_API, { params: custOptionsQuery({ custNm: query, useYn: 'Y' }), showLoading: false })
          .then((res) => {
            this.custOptions = pageRows(res.data).map((c) => ({
              custCd: c.custCd,
              custNm: c.custNm,
              custId: c.custId,
            }))
          })
          .finally(() => {
            this.custSearchLoading = false
          })
      }, 300)
    },
    // 클립보드 쓰기는 한 곳(`utils/clipboard`)이다 — 거절(권한·비보안 문맥)을 값으로 받아 사실대로 말한다
    copyQrUrl: function (row) {
      return copyText(row.qrUrl).then((copied) =>
        copied
          ? this.mainVue.$message({ type: 'success', message: CALLPOP_TEXT.copied })
          : this.mainVue.$message({ type: 'warning', message: CALLPOP_TEXT.copyFailed })
      )
    },
    showPlaceQr: function () {
      if (!this.qrUrl) return
      if (typeof AraleQRCode === 'undefined') return

      const target = document.getElementById('place_qr_preview')
      if (!target) return

      target.innerHTML = ''
      target.appendChild(new AraleQRCode({ text: this.qrUrl, size: 160 }))
    },
    /** 치수·비율만 본다 — 형식과 크기는 파일을 디코드하기 **전에** `rejectsImage` 가 이미 물었다 */
    validateImage: function (file, rules) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => {
          const { width, height } = img
          URL.revokeObjectURL(img.src)
          if (width < rules.minWidth || height < rules.minHeight) {
            reject(`이미지가 너무 작습니다. 최소 ${rules.minWidth}x${rules.minHeight}px (현재 ${width}x${height}px)`)
            return
          }
          if (width > rules.maxWidth || height > rules.maxHeight) {
            reject(`이미지가 너무 큽니다. 최대 ${rules.maxWidth}x${rules.maxHeight}px (현재 ${width}x${height}px)`)
            return
          }
          const ratio = width / height
          const targetRatio = rules.ratioWidth / rules.ratioHeight
          if (Math.abs(ratio - targetRatio) > rules.ratioTolerance) {
            reject(
              `이미지 비율이 맞지 않습니다. ${rules.ratioWidth}:${rules.ratioHeight} 비율을 권장합니다. (현재 ${width}:${height})`
            )
            return
          }
          resolve()
        }
        img.onerror = () => {
          URL.revokeObjectURL(img.src)
          reject('이미지 파일을 읽을 수 없습니다.')
        }
        img.src = URL.createObjectURL(file)
      })
    },
    // 이미지 삭제 — 파일 칸에 지움 표시(`utils/storedFile.fileRemoval`, 빈 값은 서버가 「유지」로 읽는다)
    removeThumbnail: function () {
      Object.assign(this.inputForm, fileRemoval('thumbnailUrl', 'thumbnailFile'))
    },
    removeAdImage: function () {
      Object.assign(this.inputForm, fileRemoval('adImageUrl', 'adImageFile'))
    },
    /**
     * 서버 `PlaceImageRules` 가 통과시키는 것(PNG·JPEG · 원본 2MB 이하)을 화면이 **읽기 전에** 먼저 묻는다.
     * 미리보기까지 만든 뒤 저장에서 400 을 만나는 것이 종전 동작이었다(판정은 `utils/placeImage` 한 곳).
     */
    rejectsImage: function (file) {
      const message = placeImageRejection(file && file.raw)
      if (!message) return false
      this.mainVue.$message({ type: 'error', message })

      return true
    },
    onThumbnailChange: async function (file) {
      if (this.rejectsImage(file)) return
      try {
        await this.validateImage(file.raw, {
          minWidth: 200,
          minHeight: 200,
          maxWidth: 3000,
          maxHeight: 3000,
          ratioWidth: 1,
          ratioHeight: 1,
          ratioTolerance: 0.2,
        })
      } catch (msg) {
        this.mainVue.$message({ type: 'error', message: msg })
        return
      }
      const reader = new FileReader()
      reader.onload = (e) => {
        this.inputForm.thumbnailFile = e.target.result
      }
      reader.readAsDataURL(file.raw)
    },
    onAdImageChange: async function (file) {
      if (this.rejectsImage(file)) return
      try {
        await this.validateImage(file.raw, {
          minWidth: 400,
          minHeight: 200,
          maxWidth: 3000,
          maxHeight: 1500,
          ratioWidth: 2,
          ratioHeight: 1,
          ratioTolerance: 0.3,
        })
      } catch (msg) {
        this.mainVue.$message({ type: 'error', message: msg })
        return
      }
      const reader = new FileReader()
      reader.onload = (e) => {
        this.inputForm.adImageFile = e.target.result
      }
      reader.readAsDataURL(file.raw)
    },
    // ── 편성 후보 뱃지·복합 노출순서 (재정리 §3·§4) — 판정은 서버(PlaceEntryPolicy)가 내리고 화면은 그 값만 그린다 ──
    // 뱃지·사유 줄·「추가」 잠금이 모두 이 한 답을 읽는다 — 판정별 표시는 순수 모듈(`candidateEntryView`)이 소유한다
    entryTag: function (store) {
      return candidateEntryView(store)
    },
    // 후보 행 둘째 줄 — 입점 표시·거리가 없으면(비콜팝 플레이스·판정 없는 행·거리 축 꺼짐) 그 자리를 빼고, 구분점도 붙이지 않는다
    availableMetaText: function (store) {
      return [store.storeId, subscriptionTextOf(store, this.selectedPlaceCallpopOwned), candidateDistanceText(store)]
        .filter(Boolean)
        .join(' · ')
    },
    // 고정하면 고정 블록의 끝에, 해제하면 비고정 블록의 앞에 둔다 — 순위는 보이는 순서가 정하지 숨은 배열 위치가 정하지 않는다
    togglePinned: function (store) {
      const others = this.storeForm.registeredStores.filter((item) => item.storeCd !== store.storeCd)
      const toggled = { ...store, pinned: !store.pinned }
      const pinned = others.filter((item) => item.pinned)
      const unpinned = others.filter((item) => !item.pinned)
      this.storeForm.registeredStores = pinned.concat([toggled], unpinned)
    },
    movePinned: function (store, delta) {
      const pinned = this.pinnedStores.slice()
      const from = pinned.findIndex((item) => item.storeCd === store.storeCd)
      const to = from + delta
      if (from < 0 || to < 0 || to >= pinned.length) return
      pinned.splice(to, 0, pinned.splice(from, 1)[0])
      this.storeForm.registeredStores = pinned.concat(this.unpinnedStores)
    },
    /**
     * 편성 다이얼로그를 연다 — **대상이 바뀌면 조회 세대를 올린다**(R1 low #8).
     *
     * 세대의 뜻은 「새 검색」이 아니라 **「이 다이얼로그가 보는 대상」**이다. A 의 후보 조회가 떠 있는 동안
     * B 를 열면 세대가 같아 A 의 응답이 B 의 칸에 들어가고, 실패 갈래에서는 A 의 실패 문구와 「다시 시도」
     * 버튼이 B 위에 그려진다(그 버튼은 B 를 조회하므로 보는 것과 누르는 것이 다르다). 여기서 한 번
     * 올리면 진행 중인 앞 조회가 구조적으로 버려진다 — 호출부마다 취소 분기를 더하지 않는다.
     */
    openStoreDialog: function (row) {
      this.availableSeq += 1
      this.selectedPlaceId = row.id
      this.selectedPlaceName = row.name
      // 목록 행이 서버 사실을 싣고 온다 — 후보 0건 문구가 이 축으로 갈린다(⑧)
      this.selectedPlaceCallpopOwned = isCallpopOwned(row)
      this.storeForm = this.initStoreForm()
      this.mainVue.$axios.get(
        `${this.url}/${row.id}/stores`,
        function (result) {
          this.storeForm.storeOrder = result.storeOrder || 'AUTO'
          this.storeForm.conditionExemptYn = result.conditionExemptYn || 'N'
          // 입점 필터는 편성 판정이 걸리는 플레이스(콜팝 소유·조건 적용)에서만 기본으로 켠다 — 그 밖은
          // 미입점 매장도 편성 대상이다. 「걸리는가」는 서버가 답한 사실이다(`entryConditioned`)
          this.storeForm.subscribedOnly = subscribedOnlyDefault(result)
          this.storeForm.registeredStores = (result.registeredStores || []).map((s) => ({ ...s, pinned: !!s.pinned }))
          this.storeDialogVisible = true
          this.searchAvailableStores()
        }.bind(this)
      )
    },
    // 새 검색은 진행 중인 조회를 기다리지 않고 세대를 올린다 — 늦게 온 옛 응답은 버린다(PartnerLinkPanel.requestSeq 와 같은 패턴)
    searchAvailableStores: async function () {
      this.availableSeq += 1
      this.storeForm.availablePage = 0
      this.storeForm.availableStores = []
      this.storeForm.availableHasMore = false
      // 이 조건이 지금부터의 목록을 만든다 — 빈 목록의 안내가 읽는 값이다(`availableEmptyText`)
      this.storeForm.availableFilter = {
        q: this.storeForm.availableSearchQ,
        region: this.storeForm.availableRegion,
      }
      await this.fetchAvailableStores()
    },
    /**
     * 후보 조회 — **실패를 이 함수가 값으로 끝낸다**(`availableFailed`).
     *
     * 종전에는 실패가 이 함수 밖으로 던져졌고 세 호출부가 모두 await 하지 않아 unhandled rejection 이
     * 됐다. 호출부마다 `catch` 를 붙이는 것은 같은 규칙을 셋으로 복제하는 것이라, 조회를 소유한 이
     * 함수가 실패를 화면 상태로 접는다 — 그러면 던질 것이 없어 호출부의 누락도 사라진다.
     */
    fetchAvailableStores: async function () {
      if (!this.selectedPlaceId) return
      const seq = this.availableSeq
      this.storeForm.availableLoading = true
      try {
        const response = await this.$axios.get(
          `${this.url}/${this.selectedPlaceId}/stores/available`,
          Object.assign(
            {
              params: {
                q: this.storeForm.availableSearchQ,
                region: this.storeForm.availableRegion,
                subscribedOnly: this.storeForm.subscribedOnly,
                page: this.storeForm.availablePage,
                size: 50,
              },
            },
            PLACE_STORE_CONFIG
          )
        )
        if (seq !== this.availableSeq) return
        const data = response.data || {}
        this.storeForm.availableStores = this.storeForm.availableStores.concat(data.items || [])
        this.storeForm.availableHasMore = data.hasMore || false
        this.storeForm.availableFailed = ''
      } catch (error) {
        if (seq !== this.availableSeq) return
        this.storeForm.availableHasMore = false
        this.storeForm.availableFailed = httpErrorMessage(error, this.placeText.availableLoadFailed)
      } finally {
        if (seq === this.availableSeq) this.storeForm.availableLoading = false
      }
    },
    loadMoreStores: async function (e) {
      if (this.storeForm.availableLoading || !this.storeForm.availableHasMore) return
      const el = e.target
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
        this.storeForm.availablePage++
        await this.fetchAvailableStores()
      }
    },
    addStore: function (store) {
      if (this.storeForm.registeredStores.find((item) => item.storeCd === store.storeCd)) return
      this.storeForm.registeredStores.push({ ...store, pinned: false })
      this.storeForm.availableStores = this.storeForm.availableStores.filter((item) => item.storeCd !== store.storeCd)
    },
    // 뺀 매장은 후보 맨 위의 「되돌리기」 행이다 — 후보 재조회는 DB 등록 매장을 빼므로(저장 전까지 여전히 등록 상태) 되돌릴 수 없다.
    // 서버 판정(entry·subscription·blockedBy·ineligibleReasons)은 이 행에 없으니 지어내지 않고 비운다 — 「추가」는 열어 둔다(이미 등록된 매장이라 저장 시 판정 대상이 아니다, PlaceEntryPolicy.added).
    removeStore: function (store) {
      const restored = {
        ...store,
        pinned: false,
        entry: undefined,
        subscription: undefined,
        blockedBy: undefined,
        ineligibleReasons: undefined,
      }
      this.storeForm.registeredStores = this.storeForm.registeredStores.filter((item) => item.storeCd !== store.storeCd)
      this.storeForm.availableStores = [restored].concat(
        this.storeForm.availableStores.filter((item) => item.storeCd !== store.storeCd)
      )
    },
    /**
     * 편성 저장 — 막힌 저장(`NOT_PARTICIPATING`·`INELIGIBLE`·`OUT_OF_RANGE`·`BLOCKED_IN_OTHER_GENERAL` 400)은 **다이얼로그 안에 남는다**(⑨).
     *
     * 서버 문장이 사유의 정본이고, 화면은 그 문장이 번호로 가리킨 매장의 이름을 덧붙인다
     * (`entryBlockedText`). 다이얼로그를 닫지 않는 이유: 사람이 할 일이 그 안에 있다(그 매장을 뺀다).
     */
    saveStores: async function () {
      if (!this.selectedPlaceId) return
      this.storeForm.saveFailed = ''

      try {
        await this.$axios.put(
          `${this.url}/${this.selectedPlaceId}/stores`,
          {
            storeOrder: this.storeForm.storeOrder,
            storeCds: this.storeForm.registeredStores.map((item) => item.storeCd),
            pinnedStoreCds: this.storeForm.storeOrder === 'PINNED' ? this.pinnedStores.map((item) => item.storeCd) : [],
          },
          PLACE_STORE_CONFIG
        )
      } catch (error) {
        this.storeForm.saveFailed = entryBlockedText(
          httpErrorMessage(error, this.placeText.storesSaveFailed),
          this.storeForm.registeredStores
        )

        return
      }
      this.mainVue.$message({ type: 'success', message: '저장되었습니다.' })
      this.storeDialogVisible = false
      this.search()
    },
  },
}
</script>

<style scoped>
/* 비활성 컨트롤은 마우스 이벤트를 내지 않으므로 툴팁은 감싼 span 이 받는다 */
.lifecycle-control {
  display: inline-block;
}

.place-summary {
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
  color: #606266;
}

.hint-row {
  margin-top: 8px;
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: #909399;
}

.ok-text {
  color: #67c23a;
}

.error-text {
  color: #f56c6c;
}

/* 소유 없음·경고는 오류가 아니다 — 빨강과 회색 사이의 자리 */
.warn-text {
  color: #e6a23c;
}

/* 후보 0건·조회 실패 안내는 행 하나를 가운데로 쓴다(목록의 「등록된 매장이 없습니다」와 같은 결).
   색은 이 클래스가 정하지 않는다 — 실패는 `error-text`, 0건은 `muted-text` 로 갈린다 */
.store-empty {
  justify-content: center;
  gap: 8px;
  text-align: center;
}

.muted-text {
  color: #909399;
}

.store-save-failed {
  margin-top: 12px;
  padding: 10px;
  background: #fef0f0;
  border-radius: 4px;
  word-break: break-all;
}

.qr-preview {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.qr-preview__url {
  word-break: break-all;
}

.qr-preview__canvas {
  min-height: 160px;
}

.detail-stores {
  margin-top: 20px;
}

.detail-store-tag {
  margin-right: 8px;
  margin-bottom: 8px;
}

.store-panel {
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 16px;
  height: 520px;
  display: flex;
  flex-direction: column;
}

.store-panel__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.store-panel__count {
  background: var(--color-warning);
  color: #fff;
  border-radius: 10px;
  padding: 1px 8px;
  font-size: 12px;
  font-weight: 600;
}

.store-order-setting {
  margin-bottom: 12px;
  padding: 12px;
  background: #fafafa;
  border-radius: 6px;
}

.store-order-setting__label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #303133;
}

.store-order-setting__btns {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.store-order-setting__btns .el-button {
  flex: 1;
}

.store-order-setting__desc {
  font-size: 12px;
  color: #909399;
}

.store-order-setting__desc i {
  margin-right: 4px;
}

.store-dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.store-dialog-footer__status {
  font-size: 13px;
  color: var(--color-warning);
  font-weight: 500;
}

.store-dialog-footer__status i {
  margin-right: 4px;
}

.store-search {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.store-scroll-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.store-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
}

.store-order,
.drag-handle {
  width: 28px;
  text-align: center;
  color: #909399;
}

.drag-handle {
  cursor: grab;
}

.store-row__info {
  flex: 1;
  min-width: 0;
}

.store-row__name {
  font-weight: 600;
}

.store-row__meta {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}

.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
}

.avatar-uploader /deep/ .el-upload:hover {
  border-color: var(--color-primary);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}

.ad-avatar {
  width: 280px;
  height: 140px;
}

.ad-avatar-icon {
  width: 280px;
  height: 140px;
  line-height: 140px;
}

.image-upload-wrap {
  position: relative;
  display: inline-block;
}

.image-delete-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 1;
}

.image-guide {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
}
.sub-text {
  color: #909399;
  font-size: 12px;
}
</style>
